export const ENV = {
  MODE: import.meta.env.VITE_MODE,
  MAIN_HOST: import.meta.env.VITE_MAIN_HOST,
  API_HOST: import.meta.env.VITE_API_HOST,
  EXPORT_FILE: import.meta.env.VITE_EXPORT_FILE,
  MEDIA_HOST: import.meta.env.VITE_MEDIA_HOST,
  IMG_HOST: import.meta.env.VITE_IMG_HOST,
  KTP_HOST: import.meta.env.VITE_KTP_HOST,
  EXPORT_HOST: import.meta.env.VITE_EXPORT_HOST,
  IMAGE_WL: import.meta.env.VITE_IMAGE_WL,
  SELF_HOST: import.meta.env.VITE_SELF_HOST,
  DEFAULT_IMG: import.meta.env.VITE_DEFAULT_IMG,
  MAP_KEY: import.meta.env.VITE_MAP_KEY,
  MSG_WSS_URL: import.meta.env.VITE_MSG_WSS_URL,
  MESSAGE_API_URL: import.meta.env.VITE_MESSAGE_API_URL,
  MSG_COMPANY_ID: import.meta.env.VITE_MSG_COMPANY_ID,
  MSG_MEDIA_HOST: import.meta.env.VITE_MSG_MEDIA_HOST,
  MESSAGE_API_URL_V2: import.meta.env.VITE_MESSAGE_API_URL_V2,
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  PUBLIC_URL: import.meta.env.VITE_PUBLIC_URL,
  UPLOAD_IMAGE_ENDPOINT: import.meta.env.VITE_UPLOAD_IMAGE_ENDPOINT,
  UPLOAD_ALLOW_BASE64: import.meta.env.VITE_UPLOAD_ALLOW_BASE64 === 'true',
};
